import { useState, useCallback } from 'react';
import { EditorTab } from '../types';
import { CODE_MAP } from '../utils/codeTemplates';
import { lineCount } from '../utils/formatters';
import { useAppStore } from '../store/appStore';

export function useEditor() {
  const [activeTab, setActiveTab] = useState<EditorTab>('app');
  const { editorCode, setEditorCode } = useAppStore();

  const getCode = useCallback(
    (tab: EditorTab): string => {
      if (tab === 'app') return editorCode;
      return CODE_MAP[tab] ?? '';
    },
    [editorCode]
  );

  const setCode = useCallback(
    (tab: EditorTab, value: string) => {
      if (tab === 'app') setEditorCode(value);
    },
    [setEditorCode]
  );

  const copyCode = useCallback(() => {
    const code = getCode(activeTab);
    navigator.clipboard?.writeText(code).catch(() => {});
  }, [activeTab, getCode]);

  const currentCode = getCode(activeTab);
  const lines = lineCount(currentCode);
  const chars = currentCode.length;

  const languageMap: Record<EditorTab, string> = {
    app: 'TypeScript',
    manifest: 'JSON',
    arch: 'Markdown',
    styles: 'CSS',
  };

  return {
    activeTab,
    setActiveTab,
    currentCode,
    setCode: (value: string) => setCode(activeTab, value),
    copyCode,
    lines,
    chars,
    language: languageMap[activeTab],
  };
}
